import reportPackage from './reportPackage'
import reportFriendGetFriend from './reportFriendGetFriend'
import reportAddPoint from './reportAddPoint'
import reportNotifyBirthDay from './reportNotifyBirthDay'
import reportReceipt from './reportReceipt'
import reportBroadcast from './reportBroadcast.vue'
import reportBirtdayPoint from './reportBirtdayPoint.vue'
import reportGetFriend from './reportGetFriend.vue'
import reportSpecialPoin from './reportSpecialPoin.vue'
import reportFeedbackBPV from './reportFeedbackBPV.vue'
import reportQRCodeLot from './reportQRCodeLot.vue'

export default {
  reportPackage,
  reportFriendGetFriend,
  reportAddPoint,
  reportNotifyBirthDay,
  reportReceipt,
  reportBroadcast,
  reportBirtdayPoint,
  reportGetFriend,
  reportSpecialPoin,
  reportFeedbackBPV,
  reportQRCodeLot
}



// WEBPACK FOOTER //
// ./src/components/Reports/index.js